<template>
  <Dialog
    ref="dialogRef"
    :dialogObject="dialogPayOpt"
    @dialogClose="closeDialogPay"
    class="dialog-hastit"
  >
  
    <div class="pay-box">
      <div class="pay-con">
        <div class="item">
          <p class="tit">{{$t("select payment")}}：</p>
          <el-radio-group  class="pay-method" v-model="pay_method">
            <div class="item" :class="{'active': pay_method == 1}" v-if="$t('lang') == 'cn'">
                <div class="icon"><img src="@/assets/images/pay-wechat.png" :alt="$t('Wechat Pay')"></div>
                <p class="p">{{$t('Wechat Pay')}}</p>
                <el-radio :label="1" class="chkbtn"></el-radio>
            </div>
            <div class="item" :class="{'active': pay_method == 2}">
              <div class="icon"><img src="@/assets/images/pay-alipay.png" :alt="$t('Alipay Pay')"></div>
              <p class="p">{{$t('Alipay Pay')}}</p>
              <el-radio :label="2" class="chkbtn"></el-radio>
            </div>
            <div class="item" :class="{'active': pay_method == 3}" v-if="$t('lang') == 'en'">
              <div class="icon"><img src="@/assets/images/pay-xianxia.png" :alt="$t('Offline payment')"></div>
              <p class="p">{{$t("Offline payment")}}</p>
              <el-radio :label="3" class="chkbtn"></el-radio>
            </div>
          </el-radio-group>
          <p class="fcbase">{{$t("payment within 2 hours")}}</p>
        </div>

        <div class="item">
          <p class="tit">{{$t("Order information")}}：</p>
          <div class="pay-table">
            <div class="row">
              <p class="th">{{$t("Order number")}}</p>
              <p class="td">{{data.order_sn}}</p>
            </div>
            <div class="row">
              <p class="th">{{$t("truename")}}</p>
              <p class="td">{{visitor.truename}}</p>
            </div>
            <div class="row">
              <p class="th">{{$t("mobile")}}</p>
              <p class="td">{{visitor.mobile}}</p>
            </div>
            <div class="row">
              <p class="th">{{$t("email")}}</p>
              <p class="td">{{visitor.email}}</p>
            </div>
            <div class="row">
              <p class="th">{{$t("number")}}</p>
              <p class="td">{{data.total_number}}</p>
            </div>
            <div class="row">
              <p class="th">{{$t("unit price")}}</p>
              <p class="td">{{data.event_amount}}</p>
            </div>
            <div class="row">
              <p class="th">{{$t("total order price")}}</p>
              <p class="td">{{data.total_price}}</p>
            </div>
          </div>
        </div>

        <div class="item result-item">
          <p class="p">{{$t("Discount amount")}}： <span class="fcdeep">-{{$t("￥")}}{{data.coupon_money}}</span> </p>
          <p class="p">{{$t("Amount actually paid")}}： <span class="fcdeep">{{$t("￥")}}{{data.payment_money}}</span> </p>
        </div>
      </div>

      <div class="btnbox">
        <el-space :size="10">
          <el-button type="primary" size="large" @click="doPayment" :loading="loading">{{$t("submit payment")}}</el-button>
          <router-link :to="`${$t('baseurl')}/onsite/orders`" v-if="showOrdersBtn"><el-button type="warning" size="large">{{$t("View order")}}</el-button></router-link>
        </el-space>
      </div>
    </div>
  </Dialog>

  <!-- 支付宝支付 -->
  <Dialog
    ref="dialogRef"
    :dialogObject="dialogAlipayOpt"
    @dialogClose="checkPayStatus"
    @dialogSuccess="checkPayStatus"
    class="dialog-hastit"
  >
    <div class="pay-pop">
      <p class="tit">{{$t("paying")}}</p>
      <p class="p">{{$t("open Alipay payment interface")}}</p>
    </div>
  </Dialog>

  <!-- 微信支付 -->
  <Dialog
    ref="dialogRef"
    :dialogObject="dialogWxPayOpt"
    @dialogClose="checkPayStatus"
    @dialogSuccess="checkPayStatus"
    class="dialog-hastit"
  >
    <div class="pay-pop">
      <p class="tit2">{{$t("Pay with a swipe on wechat")}}</p>
      <p class="tit">{{$t("￥")}}{{data.payment_money}}</p>
      <div class="wxqr">
        <img :src="wx_qrcode">
      </div>
    </div>

    <!-- <template #footcon>
      <el-button type="info" plain size="large" @click="checkPayStatus">未支付</el-button>
      <el-button
        type="primary"
        @click="checkPayStatus"
        size="large"
        >已支付</el-button
      >
    </template> -->
  </Dialog>


  <!-- 线下支付-银行转账信息 -->
  <Dialog
    ref="dialogRef"
    :dialogObject="dialogBankPayOpt"
    @dialogClose="toOrder"
    class="dialog-hastit"
  >
  <bank-info></bank-info>
  </Dialog>
</template>

<script>
import showMsg from "@/utils/message";
import { reactive, toRefs, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from 'vue-i18n';
import { getUserAgent } from "@/utils/common";

import { getTicketPay, offlineTicketPayment, getTicketWxPay, checkTicketPay } from "@/api/forum";
import QRCode from 'qrcode';

import Dialog from "@/components/Dialog/Dialog.vue";
import bankInfo from "./components/bankInfo.vue";

export default {
  components: {
    Dialog,
    bankInfo
  },
  props: {
    ticket_id: {
      required: true,
      type: Number
    },
    is_payment: {
      type: Boolean,
      default: false
    },
    showOrdersBtn: {
      type: Boolean,
      default: true
    }
  },

  setup(props, ctx) {

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const { t, locale } = useI18n() 

    const state = reactive({
      loading: false,
      pay_method: 0,
      data: {},
      visitor: {},
      // 支付
      dialogPayOpt: {
        dialogVisible: false,
        width: "1000px",
        title: "",
        isFooter: false,
        clickModal: false
      },

      // 支付宝
      dialogAlipayOpt: {
        dialogVisible: false,
        width: "500px",
        title: t("Alipay Pay"),
        closeBtnText: t("paid"),
        successBtnText: t("none payment"),
        clickModal: false
      },

      // 微信支付
      wx_qrcode: "",
      dialogWxPayOpt: {
        dialogVisible: false,
        width: "500px",
        title: t("Wechat Pay"),
        closeBtnText: t("paid"),
        successBtnText: t("none payment"),
        clickModal: false
      },

      // 线下支付 
      dialogBankPayOpt: {
        dialogVisible: false,
        width: "1200px",
        title: t("Bank Transfer Information"),
        isFooter: false,
      },
      
      currentEnv: getUserAgent(),

    })

    watch(()=>props.is_payment,(newVal)=>{
      if(newVal) {
        getData();
      }
    })

    // 获取数据
    function getData() {
      getTicketPay({ticket_id: props.ticket_id, app_lang: locale.value}).then((res)=>{
        const {data } = res;
        state.data = data;
        state.visitor = data.visitor;
        state.dialogPayOpt.dialogVisible = true;
        state.dialogPayOpt.title = data.event_title;
        
      }).catch((err)=>{
        state.loading = false;
        showMsg.error(err.msg);
      })
    }

    // 关闭支付弹窗
    const closeDialogPay = ()=>{
      state.dialogPayOpt.dialogVisible = false;
      state.loading = false;
      state.pay_method = 0;
      ctx.emit("closePay");
    }

    // 关闭微信弹窗
    const closeDialogWxPay = ()=>{
      state.dialogWxPayOpt.dialogVisible = false;
      state.wx_qrcode = "";
    }

    // 支付 
    const doPayment = ()=>{
      if(state.pay_method == 0) {
        showMsg.error(t("please select payment"));
        return;
      }

      state.loading = true;

      if(state.pay_method == 3) {
        // 线下支付
        offlineTicketPayment({ticket_id: state.data.id, app_lang: locale.value}).then((res)=>{
          state.dialogPayOpt.dialogVisible = false;
          state.dialogBankPayOpt.dialogVisible = true;
        }).catch((err)=>{
          showMsg.error(err.msg);
          state.loading = false;
        })
      }

      if(state.pay_method == 2) {
        // 支付宝支付
        window.open(`/alipay/onsiteforums/${state.data.id}` ,'about:blank');
        state.dialogAlipayOpt.dialogVisible = true;
        state.loading = false;
      }
      
      if(state.pay_method == 1) {
        if(state.currentEnv == "wx") {
          // 手机微信端支付
          doWxJsapiPay();
          return;
        }
        // 微信支付
        getTicketWxPay({ticket_id: state.data.id, app_lang: locale.value}).then((res)=>{
          const {data} =res;

          if(data.result_code.toLowerCase()=="fail") {
            state.loading = false;
            showMsg.error(data.err_code_des || "该订单有问题，请联系主办方管理员！");
            return;
          }

          if(data.trade_type=="NATIVE"){
            state.loading = false;
            state.dialogWxPayOpt.dialogVisible = true;

            
            QRCode.toDataURL(data.code_url, { width: 100, margin: 0 }).then(res=>{
              state.wx_qrcode = res;
            }).catch((err)=>{
              showMsg.error("微信支付二维码生成失败，请刷新重试");
            })
            
          }else if(data.trade_type=="MWEB"){
            state.loading = false;
            window.location.href=data.mweb_url;
          }
        }).catch((err)=>{
          showMsg.error(err.msg);
          state.loading = false;
        })
      }
    }

    // 支付状态
    const checkPayStatus = ()=>{
      checkTicketPay({ticket_id: state.data.id, app_lang: locale.value}).then((res)=>{
        const {data} =res;
        state.dialogAlipayOpt.dialogVisible = false;
        state.dialogWxPayOpt.dialogVisible = false;
        state.wx_qrcode = "";
        // -1取消 1待付款 2已付款 3待确认 -2退款
        if(data.status == 2) {
          showMsg.success(t("You have paid successfully, to My Ticket"));
          state.dialogPayOpt.dialogVisible = false;
          state.pay_method = 0;
          ctx.emit("successPay",state.pay_method);

        }else {
          showMsg.error(t("none payment"));
        }
        
      }).catch((err)=>{
        state.dialogAlipayOpt.dialogVisible = false;
        state.dialogWxPayOpt.dialogVisible = false;
        // state.dialogPayOpt.dialogVisible = false;
        // state.pay_method = 0;
        // state.wx_qrcode = "";
        showMsg.error(err.msg);
        ctx.emit("closePay");
      })
    }

    const doWxJsapiPay = () => {
      const url = `https://visitor.sialchina.cn/wxpay/onsiteforums/${state.data.id}?redirect=${route.path}`;
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx328b19835e4ac06e&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=${state.data.id}#wechat_redirect`;
    }

    const toOrder = () => {
      state.dialogBankPayOpt.dialogVisible = false;
      ctx.emit("successPay",state.pay_method);
    }

    return {
      ...toRefs(state),
      closeDialogPay,
      doPayment,
      checkPayStatus,
      closeDialogWxPay,
      toOrder
    }
  }
}
</script>
